import React from 'react';

import PropTypes from 'prop-types';

// TODO: Flexible severity error
// TODO: Discard error on action
const Error = ({ error }) => {
  const errorMessage = getErrorMessage(error);
  if (!errorMessage) return '';

  return (
    <div className="alert warning">
      <p>{errorMessage}</p>
    </div>
  );
};

function getErrorMessage(error) {
  if (!error || !error.message) return null;
  const status = error.response && error.response.status;

  const errorMessages = {
    400: 'The data provided is invalid',
    500: 'It has been some problem. Please, try again later',
  };

  return errorMessages[status] || error.message;
}

export default Error;

Error.propTypes = {
  error: PropTypes.object,
};
